import React, { useEffect, useState } from "react";

const Healthcheck = () => {
  return <>healthcheck 200 OK... Server is working well ! 00</>;
};

export default Healthcheck;
